import React from 'react';
import EnjoyIcon from '../EnjoyIcon';
// import { log } from '#emyw/core-lib';  // eslint-disable-line

import './index.css';
const EnjoyButton = props => {
  const {
    className,
    style
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: "enjoyCertifiedIcon".concat(className ? ' '.concat(className) : ''),
    style: style
  }, /*#__PURE__*/React.createElement(EnjoyIcon, null));
};
EnjoyButton.defaultProps = {
  className: null,
  style: {}
};
export default EnjoyButton;